export default "__VITE_ASSET__KHYcoha___"